import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { showErrorToast, showSuccessToast } from "#app/notifications";
import { clientQuery } from "#modules/clients/infra/client.query";
import { clientsQuery } from "#modules/clients/infra/clients.query";
import { updateClient } from "#modules/clients/infra/updateClient.api";
import { quoteRequestsQuery } from "#modules/quoteRequests/infra/quoteRequests.query";

export const useUpdateClientMutation = ({
  clientId,
  options,
}: {
  clientId: string | undefined;
  options?: { onSuccess?: () => void; showSuccessToast?: boolean };
}) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, ...rest } = useMutation({
    mutationFn: updateClient,
    onSuccess: () => {
      void queryClient.invalidateQueries(quoteRequestsQuery());
      void queryClient.invalidateQueries(clientQuery(clientId));
      void queryClient.invalidateQueries(clientsQuery());
      if (options?.showSuccessToast) {
        showSuccessToast({ title: t("client.update.success") });
      }
      if (options?.onSuccess) {
        options.onSuccess();
      }
    },

    onError: () => {
      showErrorToast({
        title: t("common.error"),
        message: t("client.update.error"),
      });
    },
  });

  return { updateClient: mutate, updateClientAsync: mutateAsync, ...rest };
};
